<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        账号管理
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <div class="btn" @click="showDia = true">
          <i class="icon-tr-search"></i>查询
        </div>
        <router-link class="btn ml20" to="/power/user-add"
          ><i class="icon-tr-newly-added"></i>新增</router-link
        >
      </div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column prop="login_account" label="登录账号" align="center">
          </el-table-column>
          <el-table-column prop="user_name" align="center" label="真实姓名">
          </el-table-column>
          <el-table-column prop="user_phone" align="center" label="账号性质">
          </el-table-column>
          <el-table-column prop="role_value" align="center" label="账号角色">
          </el-table-column>

          <!-- <el-table-column
                            prop="STATUS"
                            align="center"
                            label="状态">
                        <template slot-scope="scope">
                            {{$map.menuStatus[scope.row.status]}}
                        </template>
                    </el-table-column> -->
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <router-link
                :to="{ path: '/power/user-add', query: { id: scope.row.uuid } }"
              >
                <el-button type="warning" size="mini" plain>编辑</el-button>
              </router-link>
              <el-popconfirm
                title="确定此删除该单位吗？"
                class="cursor"
                @confirm="changeStatus(scope.row)"
                @onConfirm="changeStatus(scope.row)"
              >
                <a slot="reference" class="red" v-if="scope.row.status == 1">
                  <el-button type="danger" size="mini" plain>删除</el-button>
                </a>
                <a slot="reference" class="blue" v-if="scope.row.status != 1">
                  开启
                </a>
              </el-popconfirm>
              <!--                            <el-popconfirm title="确定删除吗？" class="cursor" @onConfirm="changeStatus(scope.row,2)">-->
              <!--                                <a slot="reference" class="red">-->
              <!--                                    删除-->
              <!--                                </a>-->
              <!--                            </el-popconfirm>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="params.limit || 10"
        @current-change="pageChange"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, editUser } from "../../../api/user";
import { get, post } from "@/utils/http.js";
export default {
  data() {
    return {
      list: [],
      params: { page: 1, limit: 10 },
      total: 0,
      showDia: false,
      searchForm: this.$getForm("userSearch"),
      editData: {},
      remoteFuncs: {
        getSelect(resolve) {
          post("/user/manageTypeAndState").then((res) => {
            resolve(res.data.type);
          });
        },
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeStatus(it, del) {
      let status = it.status == 1 ? 0 : 1;
      if (del) status = del;
      this.$post("/user/updateuserstatus", {
        uuid: it.uuid,
        status: status,
      }).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      });
    },
    cancle() {
      this.showDia = false;
      this.resetSearch();
    },
    getList() {
      getUserList(this.params)
        .then((res) => {
          this.total = res.data.count;
          this.list = res.data.list;
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;
          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped></style>
